<template>
  <div :class="{'flex-wrap table-filter-item': label }">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      :class="{'w100': !label}"
      v-model="valueBackup"
      filterable
      remote
      :placeholder="placeholder"
      :clearable="clearable"
      :multiple="multiple"
      :size="size"
      :remote-method="search"
      @change="handleChange"
    >
      <el-option
        v-for="item in listBackup"
        :key="item.id"
        :label="item.student_name"
        :value="item.id"
        class="student-list-item"
        :disabled="!!item.is_disabled"
      >
        <v-avatar :value="item.selfie" :size="90"/>
        <div class="student-nickname-box">
          <div v-html="getKeywordHtml('姓名', item.student_name)" class="item"></div>
          <div v-html="getKeywordHtml('昵称', item.nickname)" class="item"></div>
          <div v-html="getKeywordHtml('手机号', item.phone)" class="item"></div>
          <div v-html="getKeywordHtml('卡号', item.card_number)" class="item"></div>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { index } from '@/api/student';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '输入姓名、手机号或会员卡号进行搜索',
    },
    list: {
      type: Array,
      default: () => [],
    },
    multiple: Boolean,
    clearable: Boolean,
    remote: Boolean,
    isGetIsUsedCardInvalid: Boolean,
    checkCourseWhitelistId: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    valueBackup: '',
    listBackup: [],
    keyword: '',
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) this.valueBackup = +value || '';
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
    list: {
      handler: function(list) {
        if (JSON.stringify(list) !== JSON.stringify(this.listBackup)) this.listBackup = list || [];
      },
      deep: true,
    },
    listBackup: {
      handler: function(listBackup) {
        if (JSON.stringify(listBackup) !== JSON.stringify(this.list)) this.$emit('listChange', listBackup);
      },
      deep: true,
    },
  },
  methods: {
    getKeywordHtml(label, words) {
      words = `${words}`.replace(
        RegExp(this.keyword, 'i'),
        (keyword) => `<span class='primary-color'>${keyword}</span>`,
      );
      return `${label}：<b>${words}</b>`;
    },
    async search(keyword) {
      if (!keyword) return;

      this.keyword = keyword;
      const { isError, data } = await index({
        keyword,
        is_only_list: 1,
        is_get_is_used_card_invalid: this.isGetIsUsedCardInvalid ? 1 : 0,
        check_course_whitelist_id: this.checkCourseWhitelistId,
      });
      if (!isError) this.listBackup = data || [];
    },
    handleChange(valueBackup) {
      if (!this.multiple) {
        for (let item of this.listBackup) {
          if (item.id === valueBackup) return this.$emit('change', item);
        }
      }

      if (typeof valueBackup !== 'object') return;

      const teachers = [];
      valueBackup.forEach((teacher_id) => {
        this.listBackup.forEach((teacher) => {
          if (teacher.id === teacher_id) teachers.push(teacher);
        });
      });
      this.$emit('change', teachers);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      this.valueBackup = +this.value || '';
    }

    if (this.list.length) return this.listBackup = this.list;
  },
};
</script>

<style scoped>
.student-list-item {
  display: flex;
  align-items: center;
  height: 120px;
}

.student-nickname-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
}

.item {
  height: 25px;
  line-height: 25px;
}
</style>
